import React from 'react'
// import PropTypes from 'prop-types'
import progressStyles from '../../styles/tracker-modules/progress.module.less'

//margin between bars
const barMargin = 1

function ProgressBar({
  total,
  data,
  label,
  labeledById,
  showLabels = true,
  showBarLabels = true,
  showText = false,
  labelLocation = 'end',
}) {
  // add all bar vals together
  let barTotal
  const addVals = (accumulator, currentValue) =>
    accumulator.val + currentValue.val
  barTotal = data.reduce(addVals)

  //don't exceed bar
  if (barTotal > 1) {
    barTotal = 1
  }
  return (
    <div className={progressStyles.container}>
      {/* {val < 1 && showLabels && showText && (
        <span
          className={progressStyles.annotation}
          style={{ left: `calc(${val * 100}% + .5rem)` }}
        >
          {val.toLocaleString('en-US', {
            style: 'percent',
            minimumFractionDigits: 1,
          })}{' '}
          (at least one dose)
        </span>
      )} */}
      <div
        className={progressStyles.barContainer}
        aria-labelledby={labeledById && `#${labeledById}`}
        data-label={data.length === 1 ? data[0].barStyle : 'default'}
      >
        {data.map((d, idx) => (
          <>
            {d.val < 1 && showLabels && (
              <span
                className={progressStyles.annotation}
                data-label={d.barStyle}
                style={
                  data.length > 1 && idx === 0
                    ? { left: 0 }
                    : data.length > 1
                    ? { left: `calc(${d.val * 100}%)` }
                    : { left: `calc(${d.val * 100}% + .5rem)`, top: '.25rem' }
                }
              >
                <b>
                  {d.val.toLocaleString('en-US', {
                    style: 'percent',
                    minimumFractionDigits: 1,
                  })}
                </b>{' '}
                {d.label}
              </span>
            )}
            <div
              data-label={d.barStyle}
              key={d.val}
              className={progressStyles.bar}
              // data-label={d.label}
              style={{
                flex: `calc(${d.val * 100}% - ${barMargin}px) 0 0`,
                marginRight: `${barMargin}px`,
              }}
            ></div>
          </>
        ))}
      </div>
      {showBarLabels && (
        <div className={progressStyles.labelContainer}>
          <span className={progressStyles.label}>0</span>
          <span className={progressStyles.label}>
            {labelLocation === 'start' && label} {total.toLocaleString()}{' '}
            {labelLocation === 'end' && label}
          </span>
        </div>
      )}
    </div>
  )
}

// ProgressBar.propTypes = {}

export default ProgressBar
